import { render, staticRenderFns } from "./support-top.vue?vue&type=template&id=5fa56765&scoped=true&"
import script from "./support-top.vue?vue&type=script&lang=js&"
export * from "./support-top.vue?vue&type=script&lang=js&"
import style0 from "./support-top.vue?vue&type=style&index=0&id=5fa56765&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa56765",
  null
  
)

export default component.exports